(() => {
if (window.__boscoLegacySlideshowRuntimeLoaded) return;
window.__boscoLegacySlideshowRuntimeLoaded = true;

class BoscoLegacySlideshow {
  constructor(element) {
    this.element = element;
    this.slides = Array.from(element.querySelectorAll(':scope > .slides > li'));
    this.controls = Array.from(element.querySelectorAll('.legacy-slideshow-nav a'));
    this.previousControl = element.querySelector('.legacy-slideshow-arrow--previous');
    this.nextControl = element.querySelector('.legacy-slideshow-arrow--next');
    this.currentIndex = 0;
    this.timer = null;
    this.touchStartX = null;
    this.speed = (Number(element.dataset.slideshowSpeed) || 10) * 1000;
    this.loop = element.dataset.slideshowLoop !== 'false';

    if (this.slides.length === 0) return;

    this.onControlClick = this.onControlClick.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onPreviousClick = this.onPreviousClick.bind(this);
    this.onNextClick = this.onNextClick.bind(this);
    this.onTouchStart = this.onTouchStart.bind(this);
    this.onTouchEnd = this.onTouchEnd.bind(this);

    this.controls.forEach((control) => control.addEventListener('click', this.onControlClick));
    if (this.previousControl) this.previousControl.addEventListener('click', this.onPreviousClick);
    if (this.nextControl) this.nextControl.addEventListener('click', this.onNextClick);
    document.addEventListener('keydown', this.onKeyDown);
    this.element.addEventListener('touchstart', this.onTouchStart, { passive: true });
    this.element.addEventListener('touchend', this.onTouchEnd, { passive: true });

    this.element.setAttribute('tabindex', '0');
    this.element.setAttribute('role', 'region');
    this.element.setAttribute('aria-roledescription', 'carousel');
    this.element.setAttribute('aria-label', 'Slideshow');
    this.element.classList.add('legacy-slideshow--initialized');
    this.show(0);
    this.play();
  }

  show(index) {
    if (this.slides.length === 0) return;

    this.currentIndex = (index + this.slides.length) % this.slides.length;

    this.slides.forEach((slide, slideIndex) => {
      const isActive = slideIndex === this.currentIndex;
      slide.classList.toggle('flex-active-slide', isActive);
      slide.setAttribute('aria-hidden', String(!isActive));
    });

    this.controls.forEach((control, controlIndex) => {
      const isActive = controlIndex === this.currentIndex;
      control.classList.toggle('flex-active', isActive);

      if (isActive) {
        control.setAttribute('aria-current', 'true');
      } else {
        control.removeAttribute('aria-current');
      }
    });

    if (this.previousControl) {
      this.previousControl.disabled = !this.loop && this.currentIndex === 0;
    }

    if (this.nextControl) {
      this.nextControl.disabled = !this.loop && this.currentIndex === this.slides.length - 1;
    }

    this.element.classList.remove('slider-loading');
  }

  next() {
    if (!this.loop && this.currentIndex >= this.slides.length - 1) {
      this.pause();
      return;
    }

    this.show(this.currentIndex + 1);

    if (!this.loop && this.currentIndex === this.slides.length - 1) {
      this.pause();
    }
  }

  previous() {
    if (!this.loop && this.currentIndex === 0) return;

    this.show(this.currentIndex - 1);
  }

  play() {
    this.pause();

    if (this.slides.length > 1 && (this.loop || this.currentIndex < this.slides.length - 1)) {
      this.timer = window.setInterval(() => this.next(), this.speed);
    }
  }

  pause() {
    if (this.timer !== null) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  onControlClick(event) {
    event.preventDefault();
    const index = this.controls.indexOf(event.currentTarget);

    if (index !== -1) {
      this.show(index);
      this.play();
    }
  }

  onPreviousClick() {
    this.previous();
    this.play();
  }

  onNextClick() {
    this.next();
    this.play();
  }

  onKeyDown(event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;

    const interactiveElement = event.target.closest('input, textarea, select, [contenteditable="true"]');
    if (interactiveElement) return;

    const visibleSliders = Array.from(document.querySelectorAll('.homepage_slider.legacy-slideshow--initialized'))
      .filter((slider) => slider.getClientRects().length > 0);
    const focusedSlider = document.activeElement.closest
      ? document.activeElement.closest('.homepage_slider.legacy-slideshow--initialized')
      : null;
    const targetSlider = focusedSlider || visibleSliders[0];

    if (targetSlider !== this.element) return;

    event.preventDefault();

    if (event.key === 'ArrowRight') {
      this.next();
    } else {
      this.previous();
    }

    this.play();
  }

  onTouchStart(event) {
    this.touchStartX = event.changedTouches[0].clientX;
  }

  onTouchEnd(event) {
    if (this.touchStartX === null) return;

    const distance = event.changedTouches[0].clientX - this.touchStartX;
    this.touchStartX = null;

    if (Math.abs(distance) < 50) return;

    if (distance < 0) {
      this.next();
    } else {
      this.previous();
    }

    this.play();
  }

  selectBlock(blockId) {
    const index = this.slides.findIndex((slide) => String(slide.dataset.blockId) === String(blockId));

    if (index !== -1) {
      this.pause();
      this.show(index);
    }
  }

  destroy() {
    this.pause();
    this.controls.forEach((control) => control.removeEventListener('click', this.onControlClick));
    if (this.previousControl) this.previousControl.removeEventListener('click', this.onPreviousClick);
    if (this.nextControl) this.nextControl.removeEventListener('click', this.onNextClick);
    document.removeEventListener('keydown', this.onKeyDown);
    this.element.removeEventListener('touchstart', this.onTouchStart);
    this.element.removeEventListener('touchend', this.onTouchEnd);
    this.element.classList.remove('legacy-slideshow--initialized');
    delete this.element.boscoLegacySlideshow;
  }
}

function initBoscoLegacySlideshows(root = document) {
  const sliders = [];

  if (root.matches && root.matches('.homepage_slider')) {
    sliders.push(root);
  }

  if (root.querySelectorAll) {
    sliders.push(...root.querySelectorAll('.homepage_slider'));
  }

  sliders.forEach((slider) => {
    if (!slider.boscoLegacySlideshow) {
      slider.boscoLegacySlideshow = new BoscoLegacySlideshow(slider);
    }
  });
}

function findBoscoLegacySlideshow(target) {
  const section = target.closest('.shopify-section--slideshow');
  return section ? section.querySelector('.homepage_slider') : null;
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initBoscoLegacySlideshows(), { once: true });
} else {
  initBoscoLegacySlideshows();
}

document.addEventListener('shopify:section:load', (event) => {
  initBoscoLegacySlideshows(event.target);
});

document.addEventListener('shopify:section:unload', (event) => {
  const slider = event.target.querySelector('.homepage_slider');

  if (slider && slider.boscoLegacySlideshow) {
    slider.boscoLegacySlideshow.destroy();
  }
});

document.addEventListener('shopify:block:select', (event) => {
  const slider = findBoscoLegacySlideshow(event.target);

  if (slider && slider.boscoLegacySlideshow) {
    slider.boscoLegacySlideshow.selectBlock(event.detail.blockId);
  }
});

document.addEventListener('shopify:block:deselect', (event) => {
  const slider = findBoscoLegacySlideshow(event.target);

  if (slider && slider.boscoLegacySlideshow) {
    slider.boscoLegacySlideshow.play();
  }
});
})();
